
export default {
    methods:{
		triggerValidation(){
			this.$v.$touch()
		}
    },
};
